import VendorInvoicePaymentsHtml from './templates/vendor-invoice-payments.html';

export function VendorInvoicePaymentsDirective () {
  return {
    controller: 'VendorInvoicePaymentsCtrl',
    restrict: 'E',
    templateUrl: VendorInvoicePaymentsHtml,
    scope: {
      invoice: '=',
      payments: '='
    }
  }
}